import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=70d105ab&scoped=true&lang=pug"
import script from "./BaseLoading.vue?vue&type=script&lang=js"
export * from "./BaseLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d105ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d105ab')) {
      api.createRecord('70d105ab', component.options)
    } else {
      api.reload('70d105ab', component.options)
    }
    module.hot.accept("./BaseLoading.vue?vue&type=template&id=70d105ab&scoped=true&lang=pug", function () {
      api.rerender('70d105ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseLoading.vue"
export default component.exports